import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet, apiPost } from "../utils/api_service";
const initialState = {
  region: [],
  zone: [],
  regionByCountry: [],
  regionNew: [],
  user: {},
  checkInData: {},
  topPerformingProductList: {},
  monthWiseData: [],
  onclickDateWiseOrderAmtData: [],
  onclickProdWithOrderAmtData: [],
};
let URL = endpoints.region;
let URL1 = endpoints.zone;
const regionSlice = createSlice({
  name: "region",
  initialState,
  reducers: {
    regionSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        region: row,
      };
    },
    onclickDateWiseOrderAmtSuccess: (
      state = cloneDeep(initialState),
      action
    ) => {
      const { row } = action.payload;
      return {
        ...state,
        onclickDateWiseOrderAmtData: row,
      };
    },
    onclickProdWithOrderAmtSuccess: (
      state = cloneDeep(initialState),
      action
    ) => {
      const { row } = action.payload;
      return {
        ...state,
        onclickProdWithOrderAmtData: row,
      };
    },
    regionNewSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        regionNew: row,
      };
    },

    zoneSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        zone: row,
      };
    },
    regionByCountrySuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        regionByCountry: row,
      };
    },

    topPerformingProductListSuccess: (
      state = cloneDeep(initialState),
      action
    ) => {
      const { row } = action.payload;
      return {
        ...state,
        topPerformingProductList: row,
      };
    },

    userSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        user: row,
      };
    },

    checkSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        checkInData: row,
      };
    },

    monthWiseSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        monthWiseData: row,
      };
    },
    resetState: (state = cloneDeep(initialState), action) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const {
  regionSuccess,
  regionByCountrySuccess,
  zoneSuccess,
  userSuccess,
  resetState,
  regionNewSuccess,
  checkSuccess,
  topPerformingProductListSuccess,
  monthWiseSuccess,
  onclickDateWiseOrderAmtSuccess,
  onclickProdWithOrderAmtSuccess,
} = regionSlice.actions;

export default regionSlice.reducer;

export const getRegion = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + '?sort={"sortOrder": "ASC"}',
    }).then(({ data, success }) => {
      if (success) {
        const { content } = data.data;
        const row = content.map((regionObject, index) => {
          let regionData = {
            index: index + 1,
            id: regionObject.id === null ? "" : regionObject.id,
            name:
              regionObject.name !== null && regionObject.shortName !== null
                ? regionObject.name + " (" + regionObject.shortName + ")"
                : "",
            shortName:
              regionObject.shortName === null ? "" : regionObject.shortName,
            country:
              regionObject.country === null ? "" : regionObject.country.id,
            countryName:
              regionObject.country !== null &&
              regionObject.country.name !== null
                ? regionObject.country.name
                : "",
            stateCount:
              regionObject.stateCount === null ? "" : regionObject.stateCount,
            zoneCount:
              regionObject.zoneCount === null ? "" : regionObject.zoneCount,
            districtCount:
              regionObject.districtCount === null
                ? ""
                : regionObject.districtCount,
            talukaCount:
              regionObject.talukaCount === null ? "" : regionObject.talukaCount,
            areaCount:
              regionObject.areaCount === null ? "" : regionObject.areaCount,
            beatCount:
              regionObject.beatCount === null ? "" : regionObject.beatCount,
            outletCount:
              regionObject.outletCount === null ? "" : regionObject.outletCount,

            sortOrder:
              regionObject.sortOrder === null ? "" : regionObject.sortOrder,
          };
          return regionData;
        });
        dispatch(regionSuccess({ row }));
        dispatch(regionNewSuccess({ row: content }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getRegionNew = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + "/get-all",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((regionObject, index) => {
          let regionData = {
            index: index + 1,
            id: regionObject.id === null ? "" : regionObject.id,
            name:
              regionObject.name === null
                ? ""
                : regionObject.name + " (" + regionObject.shortName + ")",
            shortName:
              regionObject.shortName === null ? "" : regionObject.shortName,
            country:
              regionObject.countryId === null ? "" : regionObject.countryId,
            countryName:
              regionObject.countryName === null ? "" : regionObject.countryName,
            stateCount:
              regionObject.stateCount === null ? "" : regionObject.stateCount,
            zoneCount:
              regionObject.zoneCount === null ? "" : regionObject.zoneCount,
            districtCount:
              regionObject.districtCount === null
                ? ""
                : regionObject.districtCount,
            talukaCount:
              regionObject.talukaCount === null ? "" : regionObject.talukaCount,
            areaCount:
              regionObject.areaCount === null ? "" : regionObject.areaCount,
            beatCount:
              regionObject.beatCount === null ? "" : regionObject.beatCount,
            outletCount:
              regionObject.outletCount === null ? "" : regionObject.outletCount,
            sortOrder:
              regionObject.sortOrder === null ? "" : regionObject.sortOrder,
          };
          return regionData;
        });
        dispatch(regionSuccess({ row }));
        dispatch(regionNewSuccess({ row: data.data }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getRegionUpdated = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL + "/get-all" + '?sort={"sortOrder": "ASC"}',
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((regionObject, index) => {
          let regionData = {
            index: index + 1,
            id: regionObject.id === null ? "" : regionObject.id,
            name:
              regionObject.name === null
                ? ""
                : regionObject.name + " (" + regionObject.shortName + ")",
            shortName:
              regionObject.shortName === null ? "" : regionObject.shortName,
            country:
              regionObject.countryId === null ? "" : regionObject.countryId,
            countryName:
              regionObject.countryName === null ? "" : regionObject.countryName,
            stateCount:
              regionObject.stateCount === null ? "" : regionObject.stateCount,
            zoneCount:
              regionObject.zoneCount === null ? "" : regionObject.zoneCount,
            districtCount:
              regionObject.districtCount === null
                ? ""
                : regionObject.districtCount,
            talukaCount:
              regionObject.talukaCount === null ? "" : regionObject.talukaCount,
            areaCount:
              regionObject.areaCount === null ? "" : regionObject.areaCount,
            beatCount:
              regionObject.beatCount === null ? "" : regionObject.beatCount,
            outletCount:
              regionObject.outletCount === null ? "" : regionObject.outletCount,
            sortOrder:
              regionObject.sortOrder === null ? "" : regionObject.sortOrder,
          };
          return regionData;
        });
        dispatch(regionSuccess({ row }));
        dispatch(regionNewSuccess({ row: data.data }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const setRegion =
  ({ row }) =>
  async (dispatch) => {
    dispatch(regionNewSuccess({ row }));
  };

export const getRegionByCountry =
  ({ countryIds }) =>
  async (dispatch) => {
    try {
      const response = apiPost({
        url: URL + "/by-countrys?countryIds=" + countryIds,
      }).then(({ data, success }) => {
        if (success) {
          const row = data.data.map((regionByCountry, index) => {
            let regionByCountryData = {
              index: index + 1,
              ...regionByCountry,
              id: regionByCountry.id === null ? "" : regionByCountry.id,
              name: regionByCountry.name === null ? "" : regionByCountry.name,
              shortName:
                regionByCountry.shortName === null
                  ? ""
                  : regionByCountry.shortName,
              sortOrder:
                regionByCountry.sortOrder === null
                  ? ""
                  : regionByCountry.sortOrder,
              countryId:
                regionByCountry.name === null ? "" : regionByCountry.country.id,
              country:
                regionByCountry.name === null
                  ? ""
                  : regionByCountry.country.name,
            };
            return regionByCountryData;
          });
          dispatch(regionByCountrySuccess({ row }));
          return { response: row, success };
        }
        return { response: [], success };
      });
      return response;
    } catch (e) {
      return { response: [], success: false };
    }
  };

export const getZoneByRegion =
  ({ regionId }) =>
  async (dispatch) => {
    try {
      const response = apiGet({
        url: URL + "/" + regionId + "/get-zone",
      }).then(({ data, success }) => {
        if (success) {
          const row = data.data.map((zoneObject, index) => {
            let zoneData = {
              index: index + 1,
              id: zoneObject.id === null ? "" : zoneObject.id,
              name: zoneObject.name === null ? "" : zoneObject.name,
              zoneName: zoneObject.name + " ( " + zoneObject.shortName + " )",
              shortName:
                zoneObject.shortName === null ? "" : zoneObject.shortName,
              sortOrder:
                zoneObject.sortOrder === null ? "" : zoneObject.sortOrder,
            };
            return zoneData;
          });
          dispatch(zoneSuccess({ row }));
          return { response: row, success };
        }
        return { response: [], success };
      });
      return response;
    } catch (e) {
      return console.error(e.message);
    }
  };

export const getZoneByRegionIds =
  ({ regionId }) =>
  async (dispatch) => {
    try {
      const response = apiGet({
        url: URL1 + "/by-regions?regionIds=" + regionId,
      }).then(({ data, success }) => {
        if (success) {
          const row = data.data.map((zoneObject, index) => {
            let zoneData = {
              index: index + 1,
              id: zoneObject.id === null ? "" : zoneObject.id,
              name: zoneObject.name === null ? "" : zoneObject.name,
              zoneName: zoneObject.name + " ( " + zoneObject.shortName + " )",
              shortName:
                zoneObject.shortName === null ? "" : zoneObject.shortName,
              sortOrder:
                zoneObject.sortOrder === null ? "" : zoneObject.sortOrder,
            };
            return zoneData;
          });
          dispatch(zoneSuccess({ row }));
          return { response: row, success };
        }
        return { response: [], success };
      });
      return response;
    } catch (e) {
      return console.error(e.message);
    }
  };

// export const getUserCountsAndOrderAmt = () => async (dispatch) => {
//   try {
//     const response = apiGet({
//       url: URL + "/user-counts-and-order-amt",
//     }).then(({ data, success }) => {
//       if (success) {
//         const userObj = data.data;
//         console.log(userObj);
//         const userData = {
//           name:
//             userObj.activeSalesTeamCount === null
//               ? ""
//               : userObj.activeSalesTeamCount,
//           activeStockStakeHolderCount:
//             userObj.activeStockStakeHolderCount === null
//               ? ""
//               : userObj.activeStockStakeHolderCount,
//           activeOutletCount:
//             userObj.activeOutletCount === null ? "" : userObj.activeOutletCount,
//           activeOutletCount:
//             userObj.newlyAddedOutletCount === null
//               ? ""
//               : userObj.newlyAddedOutletCount,
//           activeOutletCount:
//             userObj.orderAmtYTD === null ? "" : userObj.orderAmtYTD,
//           userObj: pendingBillsObj.dateWiseOrderAmt.map((userObj, index) => {
//             return {
//               index: index + 1,
//               id: userObj.id === null ? "" : userObj.id,
//               // date: zoneObject.name + " ( " + zoneObject.shortName + " )",
//               date: userObj.date === null ? "" : userObj.date,
//               count: userObj.count === null ? "" : userObj.count,
//               amt: userObj.amt === null ? "" : userObj.amt,
//             };
//           }),
//         };
//         dispatch(userSuccess({ userData }));
//         return { response: userData, success };
//       }
//       return { response: {}, success };
//     });
//     return response;
//   } catch (e) {
//     return console.error(e.message);
//   }
// };

export const getUserCountsAndOrderAmt =
  ({ jsonData }) =>
  async (dispatch) => {
    try {
      const response = apiPost({
        url: URL + "/user-counts-and-order-amt",
        postBody: jsonData,
      }).then(({ data, success }) => {
        if (success) {
          const userObj = data.data;
          // console.log(userObj);

          const row = {
            activeSalesTeamCount:
              userObj.activeSalesTeamCount === null
                ? ""
                : userObj.activeSalesTeamCount,
            activeStockStakeHolderCount:
              userObj.activeStockStakeHolderCount === null
                ? ""
                : userObj.activeStockStakeHolderCount,
            activeOutletCount:
              userObj.activeOutletCount === null
                ? ""
                : userObj.activeOutletCount,
            newlyAddedOutletCount:
              userObj.newlyAddedOutletCount === null
                ? ""
                : userObj.newlyAddedOutletCount,
            orderAmtYTD:
              userObj.orderAmtYTD === null ? "" : userObj.orderAmtYTD,
            dateWiseOrderAmt: (userObj.dateWiseOrderAmt || []).map(
              (orderObj, index) => ({
                index: index + 1,
                id: orderObj.id === null ? "" : orderObj.id,
                date: orderObj.date === null ? "" : orderObj.date,
                count: orderObj.count === null ? "" : orderObj.count,
                amt: orderObj.amt === null ? "" : orderObj.amt,
              })
            ),
          };

          dispatch(userSuccess({ row }));
          return { response: row, success };
        }

        return { response: {}, success };
      });

      return response;
    } catch (e) {
      return console.error(e.message);
    }
  };

export const getUsersCheckedInSummary =
  ({ jsonData }) =>
  async (dispatch) => {
    try {
      const response = apiPost({
        url: URL + "/users-checked-in-summary",
        postBody: jsonData,
      }).then(({ data, success }) => {
        if (success) {
          const checkObj = data.data;
          // console.log(checkObj);

          const row = {
            todaysTotalCheckedInCount:
              checkObj.todaysTotalCheckedInCount === null
                ? ""
                : checkObj.todaysTotalCheckedInCount,
            lastHourCheckedInCount:
              checkObj.lastHourCheckedInCount === null
                ? ""
                : checkObj.lastHourCheckedInCount,
            todaysOrderAmt:
              checkObj.todaysOrderAmt === null ? "" : checkObj.todaysOrderAmt,
            yesterDaysOrderAmt:
              checkObj.yesterDaysOrderAmt === null
                ? ""
                : checkObj.yesterDaysOrderAmt,

            stockStakeHolderTypesWithCheckInCount: (
              checkObj.stockStakeHolderTypesWithCheckInCount || []
            ).map((checkObj, index) => ({
              index: index + 1,
              id: checkObj.id === null ? "" : checkObj.id,
              name: checkObj.name === null ? "" : checkObj.name,
              prefix: checkObj.prefix === null ? "" : checkObj.prefix,
              checkInCount:
                checkObj.checkInCount === null ? "" : checkObj.checkInCount,
              salesTeamCount:
                checkObj.salesTeamCount === null ? "" : checkObj.salesTeamCount,
              totalOrderAmount:
                checkObj.totalOrderAmount === null
                  ? ""
                  : checkObj.totalOrderAmount,
              isActive: checkObj.isActive === null ? "" : checkObj.isActive,
            })),
          };

          dispatch(checkSuccess({ row }));
          return { response: row, success };
        }

        return { response: {}, success };
      });

      return response;
    } catch (e) {
      return console.error(e.message);
    }
  };

export const getTopPerformingProductsAndScheme =
  ({ jsonData }) =>
  async (dispatch) => {
    try {
      const response = apiPost({
        url: URL + "/top-performing-products-and-scheme-list",
        postBody: jsonData,
      }).then(({ data, success }) => {
        if (success) {
          const topPerformingObj = data.data;

          const topPerformingData = {
            topPerformingProductList:
              topPerformingObj.topPerformingProductList === null
                ? ""
                : topPerformingObj.topPerformingProductList.map(
                    (primaryObj, index) => {
                      return {
                        index: index + 1,
                        id: primaryObj.id === null ? "" : primaryObj.id,
                        name:
                          primaryObj.productName === null
                            ? ""
                            : primaryObj.productName,
                        productCode:
                          primaryObj.productCode === null
                            ? ""
                            : primaryObj.productCode,
                        groupName:
                          primaryObj.groupName === null
                            ? ""
                            : primaryObj.groupName,
                        subCategoryName:
                          primaryObj.subCategoryName === null
                            ? ""
                            : primaryObj.subCategoryName,
                        categoryName:
                          primaryObj.categoryName === null
                            ? ""
                            : primaryObj.categoryName,
                        shortName:
                          primaryObj.shortName === null
                            ? ""
                            : primaryObj.shortName,
                        description:
                          primaryObj.description === null
                            ? ""
                            : primaryObj.description,
                        qty: primaryObj.qty === null ? "" : primaryObj.qty,
                        orderAmt:
                          primaryObj.orderAmt === null
                            ? ""
                            : primaryObj.orderAmt,
                      };
                    }
                  ),
          };

          const topPerformingFocusProductData = {
            topPerformingFocusProductList:
              topPerformingObj.topPerformingFocusProductList === null
                ? ""
                : topPerformingObj.topPerformingFocusProductList.map(
                    (secondaryObj, index) => {
                      return {
                        index: index + 1,
                        id: secondaryObj.id === null ? "" : secondaryObj.id,
                        name:
                          secondaryObj.productName === null
                            ? ""
                            : secondaryObj.productName,
                        productCode:
                          secondaryObj.productCode === null
                            ? ""
                            : secondaryObj.productCode,
                        groupName:
                          secondaryObj.groupName === null
                            ? ""
                            : secondaryObj.groupName,
                        categoryName:
                          secondaryObj.categoryName === null
                            ? ""
                            : secondaryObj.categoryName,
                        subCategoryName:
                          secondaryObj.subCategoryName === null
                            ? ""
                            : secondaryObj.subCategoryName,
                        shortName:
                          secondaryObj.shortName === null
                            ? ""
                            : secondaryObj.shortName,
                        description:
                          secondaryObj.description === null
                            ? ""
                            : secondaryObj.description,
                        qty: secondaryObj.qty === null ? "" : secondaryObj.qty,
                        orderAmt:
                          secondaryObj.orderAmt === null
                            ? ""
                            : secondaryObj.orderAmt,
                      };
                    }
                  ),
          };

          const topPerformingSchemeData = {
            topPerformingSchemeList:
              topPerformingObj.topPerformingSchemeList === null
                ? ""
                : topPerformingObj.topPerformingSchemeList.map(
                    (stockHolderObj, index) => {
                      return {
                        index: index + 1,
                        id: stockHolderObj.id === null ? "" : stockHolderObj.id,
                        name:
                          stockHolderObj.name === null
                            ? ""
                            : stockHolderObj.name,

                        discription:
                          stockHolderObj.discription === null
                            ? ""
                            : stockHolderObj.discription,
                        offerCount:
                          stockHolderObj.offerCount === null
                            ? ""
                            : stockHolderObj.offerCount,
                      };
                    }
                  ),
          };

          const finalDataList = {
            ...topPerformingData,
            ...topPerformingFocusProductData,
            ...topPerformingSchemeData,
          };

          dispatch(topPerformingProductListSuccess({ row: finalDataList }));
          return { response: finalDataList, success };
        }

        return { response: {}, success };
      });
      return response;
    } catch (e) {
      console.error(e.message);
      return { response: {}, success: false };
    }
  };

export const getMonthTillDateWiseSales =
  ({ jsonData }) =>
  async (dispatch) => {
    try {
      const response = apiPost({
        url: URL + "/month-till-date-wise-sales",
        postBody: jsonData,
      }).then(({ data, success }) => {
        if (success) {
          const row = data.data.map((monthWiseData, index) => {
            let stakeholderObject = {
              index: index + 1,
              id: monthWiseData.id === null ? "" : monthWiseData.id,
              date: monthWiseData.date === null ? "" : monthWiseData.date,
              month: monthWiseData.month === null ? "" : monthWiseData.month,
              value: monthWiseData.value === null ? "" : monthWiseData.value,
            };
            return stakeholderObject;
          });
          dispatch(monthWiseSuccess({ row }));
          return { response: [], success };
        }
        return { response: [], success };
      });
      return response;
    } catch (e) {
      return { response: [], success: false };
    }
  };

export const getActiveUsers =
  ({ jsonData }) =>
  async () => {
    try {
      const response = apiPost({
        url: URL + "/by-outlets",
        postBody: jsonData,
      }).then(({ data, success }) => {
        if (success) {
          const row = data.data.map((productObj, index) => {
            let productData = {
              index: index + 1,
              id: productObj.id === null ? "" : productObj.id,
              name: productObj.name === null ? "" : productObj.name,
              value: productObj.counts === null ? "" : productObj.counts,
            };
            return productData;
          });
          return { response: row, success };
        }
        return { response: [], success };
      });
      return response;
    } catch (e) {
      return console.error(e.message);
    }
  };

export const getActiveTeamMembers =
  ({ jsonData }) =>
  async () => {
    try {
      const response = apiPost({
        url: URL + "/by-sales-teams",
        postBody: jsonData,
      }).then(({ data, success }) => {
        if (success) {
          const row = data.data.map((productObj, index) => {
            let productData = {
              index: index + 1,
              id: productObj.id === null ? "" : productObj.id,
              name: productObj.name === null ? "" : productObj.name,
              value: productObj.counts === null ? "" : productObj.counts,
            };
            return productData;
          });
          return { response: row, success };
        }
        return { response: [], success };
      });
      return response;
    } catch (e) {
      return console.error(e.message);
    }
  };

export const getActiveDealers =
  ({ jsonData }) =>
  async () => {
    try {
      const response = apiPost({
        url: URL + "/by-stock-stake-holders",
        postBody: jsonData,
      }).then(({ data, success }) => {
        if (success) {
          const row = data.data.map((productObj, index) => {
            let productData = {
              index: index + 1,
              id: productObj.id === null ? "" : productObj.id,
              name: productObj.name === null ? "" : productObj.name,
              value: productObj.counts === null ? "" : productObj.counts,
            };
            return productData;
          });
          return { response: row, success };
        }
        return { response: [], success };
      });
      return response;
    } catch (e) {
      return console.error(e.message);
    }
  };

export const getNewAddedOutlets =
  ({ jsonData }) =>
  async () => {
    try {
      const response = apiPost({
        url: URL + "/by-newly-added-outlets",
        postBody: jsonData,
      }).then(({ data, success }) => {
        if (success) {
          const row = data.data.map((productObj, index) => {
            let productData = {
              index: index + 1,
              id: productObj.id === null ? "" : productObj.id,
              name: productObj.name === null ? "" : productObj.name,
              value: productObj.counts === null ? "" : productObj.counts,
            };
            return productData;
          });
          return { response: row, success };
        }
        return { response: [], success };
      });
      return response;
    } catch (e) {
      return console.error(e.message);
    }
  };
// http://192.168.1.42:8088/api/distribution/v1/region/by-date-and-sales-team-wise-order-amt-bifurcation

export const getOnclickDateWiseOrderAmtData =
  ({ jsonData }) =>
  async (dispatch) => {
    try {
      const response = apiPost({
        url: URL + "/by-date-and-sales-team-wise-order-amt-bifurcation",
        postBody: jsonData,
      }).then(({ data, success }) => {
        if (success) {
          const row = data.data ?? [];
          dispatch(onclickDateWiseOrderAmtSuccess({ row }));
          return { response: row, success };
        }
        return { response: [], success };
      });
      return response;
    } catch (e) {
      return console.error(e.message);
    }
  };

// http://192.168.1.42:8088/api/distribution/v1/region/by-focus-product-wise-order-amt-bifurcation

export const getOnclickProdWithOrderAmtData =
  ({ jsonData }) =>
  async (dispatch) => {
    try {
      const response = apiPost({
        url: URL + "/by-focus-product-wise-order-amt-bifurcation",
        postBody: jsonData,
      }).then(({ data, success }) => {
        if (success) {
          const row = data.data ?? null;
          dispatch(onclickProdWithOrderAmtSuccess({ row }));
          return { response: row, success };
        }
        return { response: [], success };
      });
      return response;
    } catch (e) {
      return console.error(e.message);
    }
  };
